import React from 'react';
import { useTranslation } from 'react-i18next';
import { GovSkeleton } from '@gov-design-system-ce/react';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service';

export const DataBoxMessageListMainSkeleton = () => {
	const { t } = useTranslation(LocalizeNameSpaceTypes.Global);
	return (
		<div className="flex flex-col">
			<div className="py-5 px-4 border-b border-(--border-subtlest)">
				<div className="flex gap-4">
					<div className="w-full">
						<GovSkeleton
							width="100%"
							height="24px"
							aria-label={t('loading.wcag.processing', {
								namespace: LocalizeNameSpaceTypes.Global,
							})}
						/>
					</div>
					<GovSkeleton
						width="40px"
						height="24px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
				</div>
				<GovSkeleton
					width="100%"
					height="21px"
					aria-label={t('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
				/>
			</div>
			<div className="py-5 px-4 border-b border-(--border-subtlest)">
				<div className="flex gap-4">
					<div className="w-full">
						<GovSkeleton
							width="100%"
							height="24px"
							aria-label={t('loading.wcag.processing', {
								namespace: LocalizeNameSpaceTypes.Global,
							})}
						/>
					</div>
					<GovSkeleton
						width="40px"
						height="24px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
				</div>
				<GovSkeleton
					width="100%"
					height="21px"
					aria-label={t('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
				/>
			</div>
			<div className="py-5 px-4 border-b border-(--border-subtlest)">
				<div className="flex gap-4">
					<div className="w-full">
						<GovSkeleton
							width="100%"
							height="24px"
							aria-label={t('loading.wcag.processing', {
								namespace: LocalizeNameSpaceTypes.Global,
							})}
						/>
					</div>
					<GovSkeleton
						width="40px"
						height="24px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
				</div>
				<GovSkeleton
					width="100%"
					height="21px"
					aria-label={t('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
				/>
			</div>
			<div className="py-5 px-4 border-b border-(--border-subtlest)">
				<div className="flex gap-4">
					<div className="w-full">
						<GovSkeleton
							width="100%"
							height="24px"
							aria-label={t('loading.wcag.processing', {
								namespace: LocalizeNameSpaceTypes.Global,
							})}
						/>
					</div>
					<GovSkeleton
						width="40px"
						height="24px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
				</div>
				<GovSkeleton
					width="100%"
					height="21px"
					aria-label={t('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
				/>
			</div>
			<div className="py-5 px-4">
				<div className="flex gap-4">
					<div className="w-full">
						<GovSkeleton
							width="100%"
							height="24px"
							aria-label={t('loading.wcag.processing', {
								namespace: LocalizeNameSpaceTypes.Global,
							})}
						/>
					</div>
					<GovSkeleton
						width="40px"
						height="24px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
				</div>
				<GovSkeleton
					width="100%"
					height="21px"
					aria-label={t('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
				/>
			</div>
		</div>
	);
};
